import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { newHFLTypography } from '../hd-ui-kit/NewHFLTheme';


interface NewHFLFooterProps {
  contentMaxWidth?: string;
}

function NewHFLFooter({ contentMaxWidth }: NewHFLFooterProps) {
  const originHost = window.location.origin;

  const footerWrapperStyle = {
    width: '100%',
    maxWidth: contentMaxWidth || 'none',
    margin: contentMaxWidth ? '0 auto' : 0,
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    paddingLeft: {
      xs: '20px',
      sm: contentMaxWidth ? '40px' : '20px',
      md: '80px',
      lg: contentMaxWidth ? 0 : '80px',
    },
    paddingRight: {
      xs: '20px',
      sm: contentMaxWidth ? '40px' : '20px',
      md: '80px',
      lg: contentMaxWidth ? 0 : '80px',
    },
    paddingTop: { xs: '20px', sm: '24px' },
    paddingBottom: { xs: '20px', sm: '24px' },
  };

  const logoStyle = {
    display: 'block',
    width: '110px',
    height: '17px',
    marginBottom: '12px',
  };

  const linkStyle = {
    ...newHFLTypography.ctaS,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  return (
    <Box component="footer" sx={footerWrapperStyle}>
      <Box component="img" src={originHost + '/res/hd-ui-kit-images/heidrickWordmark.svg'} alt="Heidrick" sx={logoStyle} />
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        gap={{ xs: '8px', sm: '24px' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
      >
        <Link href={originHost + '/res/privacy-policy.pdf'} target="_blank" rel="noopener noreferrer" sx={linkStyle}>
          Privacy Notice
        </Link>
        <Link href="https://heidricksupport.zendesk.com/hc/en-us" target="_blank" rel="noopener noreferrer" sx={linkStyle}>
          Need help?
        </Link>
        <Typography component="span" sx={newHFLTypography.ctaS}>
          © 2027 Heidrick
        </Typography>
      </Stack>
    </Box>
  );
}

export default NewHFLFooter;
